import { render, staticRenderFns } from "./ClusterDetalleView.vue?vue&type=template&id=3f213124&scoped=true"
import script from "./ClusterDetalleView.vue?vue&type=script&lang=js"
export * from "./ClusterDetalleView.vue?vue&type=script&lang=js"
import style0 from "./ClusterDetalleView.vue?vue&type=style&index=0&id=3f213124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f213124",
  null
  
)

export default component.exports